








































































































export default function (Component) {
  Component.options.__source = "src/module/components/typed/lolth-typed-chooser.vue"
}
